export default function StatsSection() {
  const stats = [
    { value: '14+', label: 'Product Categories' },
    { value: '500+', label: 'SEO Articles' },
    { value: '100K+', label: 'Orders Tracked' },
  ];

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-stretch gap-10 lg:gap-16">
          {/* Left: Text + Stats */}
          <div className="flex-1 flex flex-col justify-center">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Data-Driven
            </h2>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              SEO / Ecommerce Hub
            </h2>
            <p className="text-sm text-foreground-500 mt-4 max-w-md leading-relaxed">
              Built for sellers who demand precision. Our oopbuy spreadsheet platform connects thousands of products across multiple categories, backed by comprehensive tracking and SEO-optimized content.
            </p>

            {/* Stats Row */}
            <div className="flex flex-wrap gap-8 md:gap-12 mt-8 md:mt-10">
              {stats.map((stat, i) => (
                <div key={i} className="flex items-start gap-0">
                  <div>
                    <p className="text-4xl md:text-5xl font-bold text-accent-500 leading-none">
                      {stat.value}
                    </p>
                    <p className="text-xs md:text-sm text-foreground-400 mt-1.5">
                      {stat.label}
                    </p>
                  </div>
                  {i < stats.length - 1 && (
                    <div className="hidden md:block w-px h-12 bg-background-300 mx-8 md:mx-12 self-center"></div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right: Decorative */}
          <div className="flex-1 relative min-h-[280px] md:min-h-[350px] overflow-hidden rounded-lg">
            <div className="absolute inset-0 bg-gradient-to-br from-accent-100/60 via-primary-100/40 to-background-100">
              {/* Abstract shapes */}
              <div className="absolute top-8 left-8 w-32 h-32 rounded-2xl bg-accent-200/60 rotate-12"></div>
              <div className="absolute top-20 right-10 w-24 h-24 rounded-full bg-primary-200/50"></div>
              <div className="absolute bottom-10 left-16 w-40 h-28 rounded-3xl bg-accent-300/40 -rotate-6"></div>
              <div className="absolute bottom-16 right-8 w-20 h-20 rounded-xl bg-primary-300/30 rotate-45"></div>
              <div className="absolute top-1/2 left-1/3 w-28 h-28 rounded-full bg-accent-100/70"></div>
              <div className="absolute top-10 right-1/4 w-16 h-16 rounded-lg bg-primary-200/40 -rotate-12"></div>
            </div>
            {/* Spreadsheet visual */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-background-50/90 backdrop-blur-sm rounded-lg px-6 py-4 border border-background-200/60">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  <span className="text-xs font-semibold text-foreground-700">OOPBuy Dashboard</span>
                </div>
                <div className="space-y-1.5">
                  <div className="h-2 w-40 bg-background-200 rounded-full"></div>
                  <div className="h-2 w-36 bg-accent-200 rounded-full"></div>
                  <div className="h-2 w-44 bg-background-200 rounded-full"></div>
                  <div className="h-2 w-32 bg-accent-200 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}